// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'
import type {SetLocationPayload} from '../actions/setLocation'

export function setLocationReducer(state: MapState, action: Action<SetLocationPayload>): MapState {

  return {
    ...state,
  }
}
